import React from 'react';
import * as Styled from './styles.js';

class Skills extends React.Component {
    render() {
        /*const SkillList = [
            {
              key: "Java",
              //image_url: photo,
            },
            {
              key: "Swift",
              //image_url: photo,
            }
          ]
          */
          return(
            <Styled.Skills>
              skill
            </Styled.Skills>
          );
    }
}

export default Skills;
